import React from 'react';
import PropTypes from 'prop-types';

import CommonRouteLayout from '@common/containers/RouteLayout';

import { useMultiStepContext } from './multiStepContext';

const RouteLayout = ({ children, backRoute, backRouteAs, ...props }) => {
  const { currentStep, handleChangeStep } = useMultiStepContext();

  const handleBackButtonClick = () => {
    if (currentStep) handleChangeStep(currentStep - 1);
  };

  return (
    <CommonRouteLayout
      backRoute={!currentStep ? backRoute : undefined}
      backRouteAs={!currentStep ? backRouteAs : undefined}
      handleBackButtonClick={handleBackButtonClick}
      {...props}
    >
      {children}
    </CommonRouteLayout>
  );
};

RouteLayout.propTypes = {
  backRoute: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.shape({}),
    }),
  ]).isRequired,
  backRouteAs: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.shape({}),
    }),
  ]).isRequired,
  children: PropTypes.node.isRequired,
};

export default RouteLayout;
